import request from '@/utils/request'

// 查询帮助树
export const getTree = (params) => {
  return request({
    url: '/api/manage/help/center/tree',
    method: 'get',
		params
  })
}

// 保存帮助内容
export const save = (data) => {
  return request({
    url: '/api/manage/help/center/save',
    method: 'post',
    data
  })
}


// 删除帮助内容
export const del = (id) => {
  return request({
    url: '/api/manage/help/center/delete/' + id,
    method: 'delete'
  })
}


// 发布帮助内容
export const publish = (type) => {
  return request({
    url: '/api/manage/help/center/publish/' + type,
    method: 'post'
  })
}

// 查看帮助详情
export const getDetail = (id) => {
  return request({
    url: '/api/manage/help/center/detail/' + id,
    method: 'get'
  })
}

export default {
  getTree,
  save,
  del,
  publish,
  getDetail,

}
